export function calculateAminoAcidFrequency(sequence, isProtein) {
  if (!sequence || typeof sequence !== "string") {
    console.warn("Invalid or empty amino acid sequence provided.");
  }
  const standards = isProtein ? "ACDEFGHIKLMNPQRSTVWY-".split("") : "ATCG-".split("");
  const frequencies = {};
  standards.forEach((a) => {
    frequencies[a] = { count: 0, percentage: 0 };
  });
  const nonStandard = {};
  let totalCount = 0;
  for (const char of sequence.toUpperCase()) {
    if (frequencies[char]) {
      frequencies[char].count++;
      totalCount++;
    } else {
      nonStandard[char] = (nonStandard[char] || 0) + 1;
    }
  }
  if (totalCount > 0) {
    for (const a of standards) {
      frequencies[a].percentage = frequencies[a].count / totalCount * 100;
    }
  }
  return {
    totalStandards: totalCount,
    // Total count of elements
    totalLength: sequence.length,
    // Total length including non-standard
    frequencies,
    nonStandard
  };
}
export const aminoAcidShortNames = {
  A: "Ala",
  C: "Cys",
  D: "Asp",
  E: "Glu",
  F: "Phe",
  G: "Gly",
  H: "His",
  I: "Ile",
  K: "Lys",
  L: "Leu",
  M: "Met",
  N: "Asn",
  P: "Pro",
  Q: "Gln",
  R: "Arg",
  S: "Ser",
  T: "Thr",
  V: "Val",
  W: "Trp",
  Y: "Tyr",
  "-": "Gaps"
};
